import { IDmCoSo } from "../../../model/respone/category/IDmCoSo";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmCoSoActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmCoSo[],
  LOAD_ERRR: "",
};
export const eDmCoSoActionIds = generateActionTypeIds(
  eDmCoSoActionsObj,
  "CO_SO"
);
export type IDmCoSoActionTypes = IGenericActionType<
  typeof eDmCoSoActionsObj,
  "CO_SO"
>;
